import {App, createApp} from "vue";
import Cart from './components/Cart.vue';
import VueSelect from 'vue-select';
import Tippy from './directives/Tippy.vue';
import Lang from './classes/Lang.js';
import Checkout from './components/Checkout.vue';
import {createVfm} from "vue-final-modal";
import ScrollTo from "./directives/ScrollTo.vue";

export default class VueLD {
    static createApp(appName: String, mount: String) {
        const app = this['createApp' + appName]();
        app.use(createVfm())
            .component('vselect', VueSelect)
            .directive('tippy', Tippy)
            .directive('scrollto', ScrollTo)
            .use(Lang, {}).mount(mount);
        return app;
    }

    static createAppCart(): App {
        return createApp(Cart);
    }

    static createAppCheckout(): App {
        return createApp(Checkout);
    }
}
